import { mixpanel, traffic2 } from '../../utils/buildAnalyticsEvents';

export const SETTINGS_EVENTS = {
  USER_ERROR_BUTTON_CLICKED: {
    ...mixpanel('GUM User Retry Button Clicked'),
    ...traffic2('marketing.user_retry.button.click')
  },
  SAVE_SENDER_DETAILS: {
    ...mixpanel('GUM Save Sender Details Click'),
    ...traffic2('marketing.save_sender_details.click')
  },
  REVERT_SENDER_DETAILS_CHANGES: {
    ...mixpanel('GUM Revert Sender Details Changes Click'),
    ...traffic2('marketing.revert_sender_details_changes.click')
  },
  SEND_EMAIL_VERIFICATION_AGAIN: {
    ...mixpanel('GUM Send Email Verification Again Click'),
    ...traffic2('marketing.send_email_verification.click')
  },
  // eslint-disable-next-line id-length
  EMAIL_VERIFICATION_PUSHER_TIMEOUT: {
    ...mixpanel('GUM Send Email with Pusher Timeout Impression'),
    ...traffic2('marketing.send_email_verificaiton.pusher_timeout.impression')
  }
};
